export default __webpack_public_path__ + "static/lions-244bf3f86386082688f5e5f731268b5d.png";